var React = require('react');

function Basket (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.148 17l.714-10h12.276l.714 10H2.148zM7 4c0-1.103.898-2 2-2 1.103 0 2 .897 2 2v1H7V4zm10.133 2.857A2 2 0 0015.138 5H13V4a4 4 0 00-8 0v1H2.862A2 2 0 00.867 6.857L0 19h18l-.867-12.143z","fillRule":"evenodd"}));
}

Basket.defaultProps = {"width":"18","height":"19"};

module.exports = Basket;

Basket.default = Basket;
